import React from "react"
import { ListarProdutosContextProvider } from "./context/ListarProdutosContextProvider"
import { ListarProdutos } from "./ListarProdutos"

export function Index() {
    return (
        <ListarProdutosContextProvider>
            <ListarProdutos />
        </ListarProdutosContextProvider>
    )
}
